export default __webpack_public_path__ + "images/c8d560d420e2dc3b60587ada82e06e41-dashboard.png";